"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _viewService = _interopRequireDefault(require("./service/view-service"));

var _typesConst = require("./const/types-const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-return-assign */
let promoVideoData;
/**
 * View api - this API will control on the caption render and timeline
 * @param {object} config  { device: and or ios, logger: window.console}
 * @param {function} asyncCallback  callback function for async operator
 */

class ViewApi {
  constructor(config, asyncCallback) {
    if (config) {
      this.logger = config.logger || function () {};

      this.asyncCallback = asyncCallback || function () {
        this.logger.warn('asyncCallback was not set');
      };
    }

    this.service = new _viewService.default(config); // extends dom element with video api

    this.video = this.service.video;

    this.video.play = () => {
      this.play();
    };

    this.video.pause = () => {
      this.pause();
    };

    Object.defineProperty(this.video, 'currentTime', {
      get: () => this.time,
      set: time => this.time = time
    });
    Object.defineProperty(this.video, 'volume', {
      get: () => this.volume,
      set: value => this.volume = value
    });
    Object.defineProperty(this.video, 'muted', {
      get: () => this.muted,
      set: value => this.muted = value
    });
    Object.defineProperty(this.video, 'paused', {
      get: () => this.paused
    });
    Object.defineProperty(this.video, 'duration', {
      get: () => this.duration
    });
  }

  set promoVideoData(data) {
    promoVideoData = data;
  }
  /**
  * Set or Get viewScale
  * @param {float} scale
  * @returns {float}
  * @example
  * // set
  * api.view.scale = 2.4;
  * // get
  * const scale = api.view.scale;
  */


  set scale(scale) {
    this.service.scale = scale; // this.clipsViewService.scale = scale;
  }

  get scale() {
    return this.service.scale;
  }
  /**
  * Set or Get timeline time
  * @param {float} time in sec
  * @returns {float} in sec
  * @example
  * // set
  * api.view.time = 2.4;
  * // get
  * const time = api.view.time;
  */


  set time(time) {
    this.service.time(time);
  }

  get time() {
    return this.service.time(null);
  }
  /**
  * Set or Get video time
  * @param {float} time in sec
  * @returns {float} in sec
  * @example
  * // set
  * api.view.currentTime = 2.4;
  * // get
  * const currentTime = api.view.currentTime;
  */


  set currentTime(time) {
    this.service.time(time);
  }

  get currentTime() {
    return this.service.time(null);
  }
  /**
  * Set or Get video volume
  * @param {float} value range [0, 1].
  * @returns {float}
  * @example
  * // set
  * api.view.volume = 0.5;
  * // get
  * const volume = api.view.volume;
  */


  set volume(value) {
    this.service.volume = value;
  }

  get volume() {
    return this.service.volume;
  }
  /**
  * Set or Get video volume
  * @param {boolean} value
  * @returns {boolean}
  * @example
  * // set
  * api.view.muted = true;
  * // get
  * const muted = api.view.muted;
  */


  set muted(value) {
    this.service.muted = value;
  }

  get muted() {
    return this.service.muted;
  }
  /**
  * Get timeline progress
  * @returns {float}
  * @example
  * // get
  * const progress = api.view.progress;
  */


  get progress() {
    return this.service.progress;
  }
  /**
  * Get timeline durarion
  * @returns {float} in sec
  * @example
  * // get
  * const duration = api.view.duration;
  */


  get duration() {
    return this.service.duration;
  }
  /**
  * Get timeline paused
  * @returns {Boolean}
  * @example
  * // get
  * const isPaused = api.view.paused;
  */


  get paused() {
    return this.service.paused;
  }
  /**
  * Play timeline
  * @param {float?} time pass start play from spacific time
  * @example
  * api.view.play(); // will play from the current time
  * api.view.play(3); // will play from 3 sec
  */


  play(time) {
    this.service.play(time);
  }
  /**
  * pause timeline
  * @example
  * api.view.pause();
  */


  pause() {
    // this.clipsViewService.onUpdate = null;
    this.service.pause(); // this.clipsViewService.pause();
  }
  /**
   * set an on on goto-idle event callback function
   * @param {function} callback
   * @example
   * function myOnGoToIdleEvent (eventName) {
   *     console.log(eventName);
   * }
   * api.view.onGoToIdleEvent(myOnGoToIdleEvent);
   */


  onGoToIdleEvent(callback) {
    this.service.captionViewService.onGoToIdleEvent = callback;
  }
  /**
  * set an on complete callback function
  * @param {function} callback
  * @example
  * function myOnComplete () {
  *     console.log('view is complete');
  * }
  * api.view.onComplete(myOnComplete);
  */


  onComplete(callback) {
    this.service.onComplete = callback;
  }
  /**
  * set an on complete callback function
  * @param {function} callback
  * @example
  * function myOnUpdate () {
  *     console.log(api.view.time);
  * }
  * api.view.onUpdate(myOnUpdate);
  */


  onUpdate(callback) {
    this.service.onUpdate = callback;
  }
  /**
  * set an on seek event callback function
  * @param {function} callback
  * @example
  * function myOnSeekEvent (ev, guid, time) {
  *     console.log(ev, guid, time);
  * }
  * api.view.onSeekEvent(myOnSeekEvent);
  */


  onSeekEvent(callback) {
    this.service.clipsViewService.onSeekEvent = callback;
  }
  /**
  * set an on play callback function
  * @param {function} callback
  * @example
  * function myOnPlayEvent (muted) {
  *     console.log(muted);
  * }
  * api.view.onPlayEvent(myOnPlayEvent);
  */


  onPlayEvent(callback) {
    this.service.onPlayEvent = callback;
  }
  /**
  * set an on pause callback function
  * @param {function} callback
  * @example
  * function myOnPauseEvent () {
  *     console.log('paused');
  * }
  * api.view.onPauseEvent(myOnPauseEvent);
  */


  onPauseEvent(callback) {
    this.service.onPauseEvent = callback;
  }
  /**
  * clear caption timeline view
  * @example
  * api.view.clear();
  */


  clear() {
    try {
      this.service.clear();
      return (0, _utils.getResponseObject)('success', {});
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * Create caption timeline will render all caption and outro
  * this is async method
  * @param {string} hash will be return in async callback message
  * @param {string?} type the view type to be created caption, clip, music default is all
  * @param {imageQuality?} the image quality between 0.1-1 - default is 1
  * @example
  * api.view.create('hs45gdjser');
  */


  create(hash, type, imageQuality) {
    const {
      watermarkData,
      clips,
      decoration: {
        decorationData
      },
      ratio,
      music,
      duration
    } = promoVideoData;
    this.service.create({
      captions: decorationData,
      watermarkData,
      clips,
      music,
      duration
    }, ratio, type, imageQuality).then(() => this.asyncCallback((0, _utils.getResponseObject)('success', {}, hash))).catch(error => this.asyncCallback((0, _utils.getResponseObject)('error', error, hash)));
  } // timelineUpdate () {
  //     try {
  //         this.service.timelineUpdate();
  //         return getResponseObject('success', {});
  //     } catch (error) {
  //         return getResponseObject('error', error);
  //     }
  // }

  /**
  * render specific object type and guid
  * this is async method
  * @param {string} guid guid of the object to render
  * @param {string} hash will be return in post message
  * @param {string} type the object type to render [caption, music, clip, watermark]
  * @example
  * api.view.render('9aa-b8a8-baa','hs45gdjser');
  */


  render(guid, hash, type = _typesConst.CAPTION, imageQuality) {
    const {
      watermarkData,
      clips,
      decoration: {
        decorationData
      },
      music,
      duration
    } = promoVideoData;
    this.service.render(guid, {
      captions: decorationData,
      watermarkData,
      clips,
      music,
      duration
    }, type, imageQuality).then(() => this.asyncCallback((0, _utils.getResponseObject)('success', {}, hash))).catch(error => this.asyncCallback((0, _utils.getResponseObject)('error', error, hash)));
  }
  /**
  * animate specific caption by guid to is idel state
  * @param {string} guid caption guid to be render
  * @param {boolean} direct when true caption will display without tween
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.goToIdle('9aa-b8a8-baa');
  * // direct
  * api.view.goToIdle('9aa-b8a8-baa', true);
  */


  goToIdle(guid, direct) {
    try {
      this.service.goToIdle(guid, direct);
      return (0, _utils.getResponseObject)('success', {});
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * will update in view specific caption by guid
  * this will not save to promo video data
  * @param {string} guid caption guid
  * @param {object} rect size and position object
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.updateCaptionSizeAndPosition('9aa-b8a8-baa', { x:10, y:30, width:660, height:170 });
  * // update only position
  * api.view.updateCaptionSizeAndPosition('9aa-b8a8-baa', { x:10, y:30 });
  */


  updateCaptionSizeAndPosition(guid, rect) {
    try {
      const value = this.service.updateCaptionSizeAndPosition(guid, rect);
      return (0, _utils.getResponseObject)('success', {
        rect: value
      });
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * will update in view specific caption by guid
  * this will not save to promo video data
  * @param {string} guid caption guid
  * @param {object} val object of key values. each key represents the input name and value is the input value
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.updateCaptionInputs('9aa-b8a8-baa', { 'prod_title#1': 'text 1', 'prod_sub#1': 'text 2' });
  */


  updateCaptionInputs(guid, val) {
    try {
      const inputs = this.service.updateCaptionInputs(guid, val);
      return (0, _utils.getResponseObject)('success', {
        inputs
      });
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * will update in view specific color by guid
  * this will not save to promo video data
  * @param {string} guid caption guid
  * @param {object} colors object that contains a list of colors
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.updateCaptionColors('9aa-b8a8-baa', {'color#1': '#000000', 'color#2': '#ffffff'});
  * api.view.updateCaptionColors('9aa-b8a8-baa', {'color#1': '#000000'});
  */


  updateCaptionColors(guid, colors) {
    try {
      const value = this.service.updateCaptionColors(guid, colors);
      return (0, _utils.getResponseObject)('success', {
        colors: value
      });
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * will update logoin view  by outro guid
  * this will not save to promo video data
  * @param {string} guid outro guid
  * @param {object} rect size and position object
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.updateLogoSizeAndPosition('9aa-b8a8-baa', { x:10, y:30, width:660, height:170 });
  * // update only position
  * api.view.updateLogoSizeAndPosition('9aa-b8a8-baa', { x:10, y:30 });
  */


  updateLogoSizeAndPosition(guid, rect) {
    try {
      this.service.updateLogoSizeAndPosition(guid, rect);
      return (0, _utils.getResponseObject)('success');
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }
  /**
  * will update logoin view  by outro guid
  * this will not save to promo video data
  * @param {string} guid outro guid
  * @param {float} scale float 1 for 100%
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example
  * api.view.updateLogoImageScale('9aa-b8a8-baa', 1);
  * // scale image to 50%
  * api.view.updateLogoImageScale('9aa-b8a8-baa', 0.5);
  */


  updateLogoImageScale(guid, scale) {
    try {
      this.service.updateLogoImageScale(guid, scale);
      return (0, _utils.getResponseObject)('success');
    } catch (error) {
      return (0, _utils.getResponseObject)('error', error);
    }
  }

}

exports.default = ViewApi;